<div class="cm-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="cm-modal" (click)="$event.stopPropagation()">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="cm-header">
      <div class="cm-header__left">
        <div class="cm-header__icon-wrap">
          <img [src]="headerIconSrc" alt="CRE" class="cm-header__icon" />
        </div>
        <h2 class="cm-header__title">{{ headerTitle }}</h2>
      </div>
      <div class="cm-header__actions">
        <button class="cm-header__btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </button>
        <button class="cm-header__btn cm-header__btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="cm-body">

      <!-- Left Column -->
      <div class="cm-col cm-col--left">

        <!-- AI Text Box -->
        <div class="cm-ai-box">
          <p class="cm-ai-box__text">{{ aiText }}</p>
        </div>

        <!-- Critical Controls Mini Card -->
        <div class="cm-mini-card">
          <div class="cm-mini-card__header">
            <img [src]="ccCard.iconSrc" [alt]="ccCard.iconAlt" class="cm-mini-card__icon" />
            <div>
              <p class="cm-mini-card__title">{{ ccCard.title }}</p>
              <p class="cm-mini-card__sub">{{ ccCard.subtitle }}</p>
            </div>
          </div>
          <div class="cm-mini-card__chart" [style.background]="chartBg(ccScore)">
            <span class="cm-mini-card__score">{{ ccScore }}%</span>
            <div #ccChartEl class="cm-apex-sparkline"></div>
          </div>

          <!-- Top 3 / Bottom 3 -->
          <div class="cm-tb3">
            <div class="cm-tb3__col">
              <div class="cm-tb3__header cm-tb3__header--top">
                <img src="assets/performance/thumbs-up.svg" alt="" class="cm-tb3__thumb" />
                Top 3
              </div>
              <div *ngFor="let p of ccTop3" class="cm-tb3__row">
                <span class="cm-tb3__name">{{ p.name }}</span>
                <span class="cm-tb3__score cm-tb3__score--green">{{ p.score }}</span>
              </div>
            </div>
            <div class="cm-tb3__divider"></div>
            <div class="cm-tb3__col">
              <div class="cm-tb3__header cm-tb3__header--bottom">
                <img src="assets/performance/thumbs-down.svg" alt="" class="cm-tb3__thumb" />
                Bottom 3
              </div>
              <div *ngFor="let p of ccBottom3" class="cm-tb3__row">
                <span class="cm-tb3__name">{{ p.name }}</span>
                <span class="cm-tb3__score cm-tb3__score--red">{{ p.score }}</span>
              </div>
            </div>
          </div>
          <p class="cm-mini-card__verification">{{ ccVerification }}</p>
        </div>

      </div>

      <!-- Right Column -->
      <div class="cm-col cm-col--right">

        <!-- CRE Mini Card -->
        <div class="cm-mini-card">
          <div class="cm-mini-card__header">
            <img [src]="creCard.iconSrc" [alt]="creCard.iconAlt" class="cm-mini-card__icon" />
            <div>
              <p class="cm-mini-card__title">{{ creCard.title }}</p>
              <p class="cm-mini-card__sub">{{ creCard.subtitle }}</p>
            </div>
          </div>
          <div class="cm-mini-card__chart" [style.background]="chartBg(creScore)">
            <span class="cm-mini-card__score">{{ creScore }}%</span>
            <div #creChartEl class="cm-apex-sparkline"></div>
          </div>

          <!-- Progress bar -->
          <div class="cm-progress-wrap">
            <div class="cm-progress-labels">
              <span class="cm-progress-labels__val">{{ creProgress.closed }}%</span>
              <span class="cm-progress-labels__val cm-progress-labels__val--mid">{{ creProgress.open }}%</span>
              <span class="cm-progress-labels__val cm-progress-labels__val--right">{{ creProgress.overdue }}%</span>
            </div>
            <div class="cm-progress-bar">
              <div class="cm-progress-bar__seg cm-progress-bar__seg--green" [style.width.%]="creProgress.closed"></div>
              <div class="cm-progress-bar__seg cm-progress-bar__seg--yellow" [style.width.%]="creProgress.open"></div>
              <div class="cm-progress-bar__seg cm-progress-bar__seg--red" [style.width.%]="creProgress.overdue"></div>
            </div>
            <div class="cm-progress-legend">
              <ng-container *ngFor="let leg of progressLegend">
                <span class="cm-progress-legend__dot" [ngClass]="leg.colorClass"></span> {{ leg.label }}
              </ng-container>
            </div>
          </div>

          <!-- Stats row -->
          <div class="cm-stats-row">
            <div *ngFor="let s of creStats" class="cm-stats-row__item">
              <span class="cm-stats-row__value">{{ s.value }}</span>
              <span class="cm-stats-row__label">{{ s.label }}</span>
            </div>
          </div>

          <!-- Overdue CRE Findings -->
          <div class="cm-overdue">
            <p class="cm-overdue__title">{{ overdueTitle }}<br /><span>{{ overdueSubtitle }}</span></p>
            <div class="cm-overdue__scroll">
              <table class="cm-overdue__table">
                <colgroup>
                  <col class="col-date" />
                  <col class="col-location" />
                  <col class="col-level" />
                </colgroup>
                <thead>
                  <tr>
                    <th *ngFor="let col of overdueColumns">
                      {{ col }} <span class="cm-overdue__search"><img [src]="searchIconSrc" alt="search" /></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of overdueFindings">
                    <td [style.color]="row.dateColor" class="cm-overdue__date">{{ row.date }}</td>
                    <td>{{ row.location }}</td>
                    <td class="cm-overdue__level">
                      {{ row.level }}
                      <button class="cm-overdue__view-btn" (click)="openFindingDetails(row)">{{ "VIEW" | translate }}</button>
                    </td>
                  </tr>
                  <tr *ngIf="overdueFindings.length === 0">
                    <td colspan="3" class="cm-overdue__empty">No overdue CRE findings</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
